import { LocalStorageRepository } from "./LocalStorageRepository";

import { Workspace } from "../../../../../types/types";
import { STORAGE_KEY_WORKSPACES } from "../../../constants";

export class WorkspaceLocalRepository extends LocalStorageRepository<Workspace> {
    constructor() {
        super(STORAGE_KEY_WORKSPACES);
    }

}

export default WorkspaceLocalRepository;
